module.exports = __webpack_public_path__ + "img/yuri.145de3fa.jpg";